// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as ContactUsRouteImport } from './routes/contact-us'
import { Route as CoreValuesRouteImport } from './routes/core-values'
import { Route as CrusadesRouteImport } from './routes/crusades'
import { Route as DonateRouteImport } from './routes/donate'
import { Route as DonationFormRouteImport } from './routes/donation-form'
import { Route as FireCarriersRouteImport } from './routes/fire-carriers'
import { Route as FireStartersAndRainCrusadersRouteImport } from './routes/fire-starters-and-rain-crusaders'
import { Route as JoinUsRouteImport } from './routes/join-us'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as ThankYouRouteImport } from './routes/thank-you'
import { Route as BlogSlugRouteImport } from './routes/blog_.$slug'
import { Route as CrusadeSlugRouteImport } from './routes/crusade.$slug'
import { Route as DonationFormMonthlyRecurringRouteImport } from './routes/donation-form_.monthly-recurring'
import { Route as TeamSlugRouteImport } from './routes/team.$slug'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const BlogRoute = BlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const ContactUsRoute = ContactUsRouteImport.update({
            id: '/contact-us',path: '/contact-us',getParentRoute: () => rootRouteImport
          })
const CoreValuesRoute = CoreValuesRouteImport.update({
            id: '/core-values',path: '/core-values',getParentRoute: () => rootRouteImport
          })
const CrusadesRoute = CrusadesRouteImport.update({
            id: '/crusades',path: '/crusades',getParentRoute: () => rootRouteImport
          })
const DonateRoute = DonateRouteImport.update({
            id: '/donate',path: '/donate',getParentRoute: () => rootRouteImport
          })
const DonationFormRoute = DonationFormRouteImport.update({
            id: '/donation-form',path: '/donation-form',getParentRoute: () => rootRouteImport
          })
const FireCarriersRoute = FireCarriersRouteImport.update({
            id: '/fire-carriers',path: '/fire-carriers',getParentRoute: () => rootRouteImport
          })
const FireStartersAndRainCrusadersRoute = FireStartersAndRainCrusadersRouteImport.update({
            id: '/fire-starters-and-rain-crusaders',path: '/fire-starters-and-rain-crusaders',getParentRoute: () => rootRouteImport
          })
const JoinUsRoute = JoinUsRouteImport.update({
            id: '/join-us',path: '/join-us',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const ThankYouRoute = ThankYouRouteImport.update({
            id: '/thank-you',path: '/thank-you',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog_/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const CrusadeSlugRoute = CrusadeSlugRouteImport.update({
            id: '/crusade/$slug',path: '/crusade/$slug',getParentRoute: () => rootRouteImport
          })
const DonationFormMonthlyRecurringRoute = DonationFormMonthlyRecurringRouteImport.update({
            id: '/donation-form_/monthly-recurring',path: '/donation-form/monthly-recurring',getParentRoute: () => rootRouteImport
          })
const TeamSlugRoute = TeamSlugRouteImport.update({
            id: '/team/$slug',path: '/team/$slug',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,BlogRoute: BlogRoute,ContactRoute: ContactRoute,ContactUsRoute: ContactUsRoute,CoreValuesRoute: CoreValuesRoute,CrusadesRoute: CrusadesRoute,DonateRoute: DonateRoute,DonationFormRoute: DonationFormRoute,FireCarriersRoute: FireCarriersRoute,FireStartersAndRainCrusadersRoute: FireStartersAndRainCrusadersRoute,JoinUsRoute: JoinUsRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,ThankYouRoute: ThankYouRoute,BlogSlugRoute: BlogSlugRoute,CrusadeSlugRoute: CrusadeSlugRoute,DonationFormMonthlyRecurringRoute: DonationFormMonthlyRecurringRoute,TeamSlugRoute: TeamSlugRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)